module.exports = __webpack_public_path__ + "icon-arrow-right-mobile-nav.svg?8c360603a637292028cdae842efedd86";